import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CierreComponent } from './components/cierre.component';

const routes: Routes = [
  { path: "consultas", component: CierreComponent },
  { path: "**", redirectTo: "consultas", pathMatch: "prefix" },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CierreRoutingModule { }
